import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FRONTEND_LINKS } from '../../Constants/FrontendLinks';
import { MobergFontFamily } from '../../Moberg';
import { Deployment, useEnvironmentVariablesProvider } from "../../Providers/EnvironmentVariablesProvider";
import { useAuthProvider } from "../../Providers/AuthProvider";

function SubpageTabs({ UID, patient, currentTab }) {
    const navigate = useNavigate()
    const [selectedTab, setSelectedTab] = useState(currentTab ? currentTab : 'Data')
    const { deployment, environmentVariables } = useEnvironmentVariablesProvider()
    const isClinical = deployment === Deployment.CLINICAL
    const exportFeatureEnabled = isClinical && !!environmentVariables?.FEATURE_FLAG_EXPORT
    const authProvider = useAuthProvider()

    // if deployment is clinical, don't show uploads tab


    function nav(tab) {
		if (!UID || selectedTab === tab) return

		if (tab === "Forms") {
            setSelectedTab('Forms')
			const navigationURL = `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.FORMS.SUBPAGES.PATIENT.MAIN}?patient_id=${UID}`
			navigate(navigationURL, { state: patient })
		} else if (tab === "Data") {
            setSelectedTab('Data')
			const navigationURL = `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.SUBPAGES.PATIENTS.MAIN}?patient_id=${UID}`
			navigate(navigationURL, { state: patient })
		} else if (tab === "Files") {
            setSelectedTab('Files')
			const navigationURL = `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.FILES.SUBPAGES.PATIENT.MAIN}?patient_id=${UID}`
			navigate(navigationURL, { state: patient })
		} else if (tab === 'Uploads') {
            setSelectedTab('Uploads')
			const navigationURL = `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.UPLOAD.SUBPAGES.PATIENT.MAIN}?patient_id=${UID}`
			navigate(navigationURL, { state: patient })
		} else if (tab === 'Exports') {
            setSelectedTab('Exports')
			const navigationURL = `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.SUBPAGES.PATIENTS.SUBPAGES.EXPORTS.MAIN}?patient_id=${UID}`
			navigate(navigationURL, { state: patient })
		} else {
            setSelectedTab('Data')
            alert('Page does not exist')
            navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)
        }
	}

    return (
        <TabsContainer>
            {!isClinical && (
                <Tab isSelected={selectedTab === 'Files'} onMouseDown={() => nav('Files')}>
                    <TabLabel isSelected={selectedTab === 'Files'}>Files</TabLabel>
                </Tab>
            )}
            {!isClinical && (
            <Tab isSelected={selectedTab === 'Forms'} onMouseDown={() => nav('Forms')}>
                <TabLabel isSelected={selectedTab === 'Forms'}>Forms</TabLabel>
            </Tab>
            )}
            {!isClinical && (
                <Tab isSelected={selectedTab === 'Uploads'} onMouseDown={() => nav('Uploads')}>
                    <TabLabel isSelected={selectedTab === 'Uploads'}>Uploads</TabLabel>
                </Tab>
            )}
            <Tab isSelected={selectedTab === 'Data'} onMouseDown={() => nav('Data')}>
                <TabLabel isSelected={selectedTab === 'Data'}>Data</TabLabel>
            </Tab>
            {exportFeatureEnabled && authProvider.permissions?.['export:view'] && (
                <Tab isSelected={selectedTab === 'Exports'} onMouseDown={() => nav('Exports')}>
                    <TabLabel isSelected={selectedTab === 'Exports'}>Exports</TabLabel>
                </Tab>
            )}
        </TabsContainer>
    );
}

export default SubpageTabs;

const TabsContainer = styled.div`
    height: 50px;
    border-radius: 24px;
    display: flex;
    margin-right: 8px;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 6px;
`;

const Tab = styled.div`
    width: fit-content;
    height: 34px;
    position: relative;
    min-width: 100px;
    text-align: center;
    background: ${props => props.isSelected ? '#1976d2' : 'transparent'};
    cursor: ${props => props.isSelected ? 'auto' : 'pointer'};
    pointer-events: ${props => props.isSelected ? 'none' : 'auto'};
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    transition: all 0.2s ease;
    

    &:hover {
        background: ${props => props.isSelected ? '#1976d2' : 'rgba(25, 118, 210, 0.1)'};
    }
`;

const TabLabel = styled.p`
    font-family: ${MobergFontFamily.REGULAR};
    font-weight: 600;
    font-size: 16px;
    color: ${props => props.isSelected ? '#ffffff' : 'var(--text-secondary-color)'};
    margin: 0;
    user-select: none;
`